
function S2_about() {
    return (
        <section className="S2_about">
            <div className="container">
                <div className="row ">
                    
                    <div className="col-lg-4 col-md-6">
                        <div className="card">
                            <span></span>
                            <i className="fa-brands fa-searchengin"></i>
                            <h4>Transparency</h4>
                            <p>Morbi non dignissim erat, a blandit felis. Suspendisse nec lorem vel orci varius congue ut vitae est.</p>

                        </div>


                    </div>
                    
                    <div className="col-lg-4 col-md-6">
                        <div className="card">
                            <span></span>
                            <i className="fa-solid fa-users-viewfinder"></i>
                            <h4>Experienced Team</h4>
                            <p>Morbi non dignissim erat, a blandit felis. Suspendisse nec lorem vel orci varius congue ut vitae est.</p>

                        </div>


                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="card">
                            <span></span>
                            <i className="fa-solid fa-user-lock"></i>
                            <h4>Security Guarantee</h4>
                            <p>Morbi non dignissim erat, a blandit felis. Suspendisse nec lorem vel orci varius congue ut vitae est.</p>

                        </div>

                    </div>








            </div>
            </div> 
        </section>
    )
}

export default S2_about;